export default __webpack_public_path__ + "static/media/ic-publish.b9533546.svg";